import { useCallback, useMemo, useState } from 'react'

import { GridRowId, GridSortItem } from '@mui/x-data-grid'

import { FplDataGrid } from 'components/common'
import { GET_PAGED_AVAILABLE_LOADS } from 'graphql/queries'
import useGetAvailableLoadsColumns from 'hooks/fplDataGridColumns/useGetAvailableLoadsColumns'

import SubmitBidDialog from './SubmitBidDialog'

function AvailableLoads() {
  const [submitBidDialog, setSubmitBidDialog] = useState<{
    id: number | null
    open: boolean
  }>({
    id: null,
    open: false,
  })

  const handleSubmitBidClick = useCallback(
    (id: GridRowId) => () => {
      setSubmitBidDialog({
        id: Number(id),
        open: true,
      })
    },
    [setSubmitBidDialog],
  )

  const handleCloseSubmitBidDialog = () => {
    setSubmitBidDialog({
      id: null,
      open: false,
    })
  }

  const columns = useGetAvailableLoadsColumns(handleSubmitBidClick)

  const queryData = useMemo(
    () => ({
      query: GET_PAGED_AVAILABLE_LOADS,
      entityName: 'availableLoads',
      defaultSortOrder: {
        field: 'ourReference',
        sort: 'desc',
      } as GridSortItem,
    }),
    [],
  )

  return (
    <>
      <FplDataGrid
        query={queryData.query}
        isHideOldData={true}
        refetchWithDelay
        entityName={queryData.entityName}
        variableSortOrder={queryData.defaultSortOrder}
        toolbar={{
          caption: 'Available Loads',
        }}
        disableSelectionOnClick
        columns={columns}
      />
      <SubmitBidDialog
        bookingId={submitBidDialog.id}
        open={submitBidDialog.open}
        onClose={handleCloseSubmitBidDialog}
      />
    </>
  )
}

export default AvailableLoads
